module.exports = __webpack_public_path__ + "img/VIP.312f0ebc.png";